import { DEAL_TYPE_OPTIONS, INVESTMENT_STAGE_OPTIONS } from 'components/global/DealForm/_helpers/dealForm.consts';
import UniversalInput from 'components/global/UniversalInput';
import { DEBT_RAISE_TYPES, PIPELINE_STATUS_OPTIONS, RATINGS_OPTIONS } from 'constants/globalConstants';
import { Col, Row } from 'react-bootstrap';
import { $form, $view } from 'signals/global.signals';
import getSelectValue from 'utils/getSelectValue';

const InvestorDealForm = () => (
  <Row>
    <Col md={10}>
      <UniversalInput
        name="name"
        label="Deal Name"
        className="mb-16"
        required
      />
    </Col>
    <Col md={2}>
      <UniversalInput
        name="rating"
        label="Rating"
        className="mb-16"
        options={RATINGS_OPTIONS}
        type="select"
      />
    </Col>
    <Col md={12}>
      <UniversalInput
        name="description"
        label="Description"
        className="mb-16"
        type="textarea"
      />
    </Col>
    <h6 className="text-gray-400 fw-bold mb-16">Company Details</h6>
    <Col md={6}>
      <UniversalInput
        name="companyName"
        label="Company Name"
        className="mb-16"
        disabled={$form.value.recordType === 'synced'}
        required={$form.value.recordType !== 'synced'}
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="companyWebsite"
        label="Company Website"
        className="mb-16"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <Col md={12}>
      <UniversalInput
        name="companyDescription"
        label="Company Description"
        className="mb-16"
        type="textarea"
        disabled={$form.value.recordType === 'synced'}
        required={$form.value.recordType !== 'synced'}
      />
    </Col>
    <h6 className="text-gray-400 fw-bold mb-16">Contact Details</h6>
    <Col md={6}>
      <UniversalInput
        name="contactFirstName"
        label="Contact First Name"
        className="mb-16"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="contactLastName"
        label="Contact Last Name"
        className="mb-16"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="contactEmail"
        label="Contact Email"
        className="mb-16"
        type="email"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="contactPhone"
        label="Contact Phone"
        className="mb-16"
        type="phone"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="contactTitle"
        label="Contact Title"
        className="mb-16"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <h6 className="text-gray-400 fw-bold mb-16">Deal Details</h6>
    <Col md={6}>
      <UniversalInput
        name="investmentStage"
        label="Investment Stage"
        className="mb-16"
        options={INVESTMENT_STAGE_OPTIONS}
        type="select"
        disabled={$form.value.recordType === 'synced'}
        required
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="typeOfRaise"
        label="Type of Raise"
        className="mb-16"
        options={DEAL_TYPE_OPTIONS}
        type="select"
        disabled={$form.value.recordType === 'synced'}
        required
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="currentRaiseSize"
        label="Raise Target"
        className="mb-16"
        type="money"
        disabled={$form.value.recordType === 'synced'}
        required
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="currentValuation"
        label="Current Valuation"
        className="mb-16"
        type="money"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="minimumInvestment"
        label="Minimum Investment"
        className="mb-16"
        type="money"
        disabled={$form.value.recordType === 'synced'}
      />
    </Col>
    {DEBT_RAISE_TYPES.includes(getSelectValue($form.value.typeOfRaise)) && (
      <>
        <h6 className="text-gray-400 fw-bold mb-16">Debt Details</h6>
        <Col md={6}>
          <UniversalInput
            name="discountPercent"
            type="percent"
            label="Discount Percent"
            className="mb-16"
            disabled={$form.value.recordType === 'synced'}
          />
        </Col>
        <Col md={6}>
          <UniversalInput
            name="interestRate"
            type="percent"
            label="Interest Rate"
            className="mb-16"
            disabled={$form.value.recordType === 'synced'}
          />
        </Col>
        <Col md={6}>
          <UniversalInput
            name="cap"
            type="money"
            label="Cap"
            className="mb-16"
            disabled={$form.value.recordType === 'synced'}
          />
        </Col>
      </>
    )}
    <h6 className="text-gray-400 fw-bold mb-16">Pipeline Details</h6>
    <Col md={6}>
      <UniversalInput
        name="teamId"
        label="Team"
        type="select"
        options={$view.value.teamOptions || []}
        className="mb-16"
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="pipelineStatus"
        type="select"
        options={PIPELINE_STATUS_OPTIONS}
        className="mb-16"
        label="Deal Stage"
        required
      />
    </Col>
    <Col md={6}>
      <UniversalInput
        name="previouslyCommitted"
        label="Target Committed"
        className="mb-16"
        type="money"
      />
    </Col>
  </Row>
);

export default InvestorDealForm;